import React from 'react';
import { IFormStatusWrapperProps } from '../interfaces/IFormStatusWrapperProps';
import { BodyText, Button, Grid, IconType, RotatingIcon, ErrorMessage } from 'ui-toolkit';
import { CoverOnTop } from '../../../shared/CoverOnTop';
import { SuccessMessage } from '../../../shared/SuccessMessage';

interface IEditFormStatusWrapperProps extends IFormStatusWrapperProps {
  updateFetchedSuccess: boolean;
  updateSuccessMessage: string | React.ReactNode;
  deleteFetchedSuccess?: boolean;
  deleteSuccessMessage?: string | React.ReactNode;
  onResetDeleteAndCancel?: () => void;
}

export const EditContactFormStatusWrapper: React.FC<IEditFormStatusWrapperProps> = ({
  fetchError,
  fetching,
  updateFetchedSuccess,
  updateSuccessMessage,
  deleteFetchedSuccess,
  deleteSuccessMessage,
  onResetDeleteAndCancel,
}) => {
  return (
    <>
      {fetching && (
        <CoverOnTop>
          <RotatingIcon type={IconType.Loading} />
        </CoverOnTop>
      )}
      {updateFetchedSuccess && (
        <CoverOnTop>
          <SuccessMessage successMessage={updateSuccessMessage} />
        </CoverOnTop>
      )}
      {deleteFetchedSuccess && (
        <CoverOnTop>
          <Grid textAlign={'center'}>
            <BodyText>{deleteSuccessMessage}</BodyText>
            <Button intent={'primary'} type={'button'} onClick={onResetDeleteAndCancel}>
              OK
            </Button>
          </Grid>
        </CoverOnTop>
      )}
      {fetchError && <ErrorMessage error={fetchError} />}
    </>
  );
};
